module.exports = __webpack_public_path__ + "static/media/league-nav-prize-breakup.24d168b4.svg";